module.exports = __webpack_public_path__ + "static/media/link_add_hover.621142f1.svg";